import { restClient } from '@/Core'

import { TENDER_REST_URL } from '../Contracts/ITender'

import type { TenderCollectionResponse, TenderRecord } from '../Contracts/ITender'

export interface LoadClientTendersParams {
    clientUuid: string
    page: number
    pageSize: number
}

/**
 * Сторінка тендерів одного клієнта для вкладки «Тендер» його картки
 * (`SPEC-025` §3.5): `filters` ядра з умовою `client.uuid`, порядок — як у
 * реєстрі (бек сортує за датою зміни). Права рядка (R-R) накладає бек — менеджер
 * бачить у вкладці лише свої тендери, як і в реєстрі.
 *
 * `forceRefresh`: ядровий клієнт кешує GET, а після збереження тендера в
 * шухляді список мусить показати зміну.
 */
export const LoadClientTendersTask = async ({
    clientUuid,
    page,
    pageSize,
}: LoadClientTendersParams): Promise<{ items: TenderRecord[]; total: number }> => {
    const filters = encodeURIComponent(JSON.stringify({ and: [{ field: 'client.uuid', op: '=', value: clientUuid }] }))
    const raw = await restClient.get(
        `${TENDER_REST_URL}?page=${page}&limit=${pageSize}&filters=${filters}`,
        undefined,
        { forceRefresh: true }
    )
    const data = raw as unknown as TenderCollectionResponse | null
    const items = (data?.items ?? []).filter((item) => typeof item?.uuid === 'string')
    const total = typeof data?.meta?.total === 'number' ? data.meta.total : items.length

    return { items, total }
}
